import { IoCreateOutline } from 'react-icons/io5'
import { BsTrash3 } from 'react-icons/bs'
import { RiMenuFill } from 'react-icons/ri'
import React, { useContext } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { setActiveSpeciality, showEspecialidadModal } from '../../../store/slices/uiSlice'
import classNames from 'classnames'
import { alertConfirm } from '../../../plugins/sweetAlert.plugin'
import { toastAdapter } from '../../../plugins/hot-toast.plugin'
import { useDeleteEspecialidadMutation } from '../../../services/rtk-query/clinicalApi'
import { PermissionsContext } from '../../../context'
import { modules, PERMISSIONS } from '../../../constants'

export const ModalOptions = ({ cell }) => {
  const { hasPermission } = useContext(PermissionsContext)
  const dispatch = useDispatch()
  const [deleteEspecialiad] = useDeleteEspecialidadMutation()
  const edit = () => {
    dispatch(setActiveSpeciality(cell))
    dispatch(showEspecialidadModal())
  }
  const onDelete = async () => {
    const response = await alertConfirm({
      cancelButtonColor: '#d33',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Si, eliminar',
      text: 'No podras revertir esta acción',
      title: '¿Estás seguro?'
    })
    console.log({ response })

    if (response) {
      toastAdapter.promise({
        promise: deleteEspecialiad(cell.id).unwrap(),
        loadingMessage: 'Eliminando especialidad',
        successMessage: 'Especialidad eliminada con éxito',
        errorMessage: 'No se pudo eliminar la especialidad'
      })
      return
    }
    console.log({ response })
  }
  return (
    <Dropdown drop="start">
      <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
        <RiMenuFill />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item
          onClick={edit}
          disabled={!hasPermission([PERMISSIONS.WRITE], modules.medicos)}
        >
          <IoCreateOutline /> Editar
        </Dropdown.Item>
        <Dropdown.Item
          className={classNames('text-danger', {
            opacity: !hasPermission([PERMISSIONS.WRITE], modules.medicos)
          })}
          onClick={onDelete}
          disabled={!hasPermission([PERMISSIONS.WRITE], modules.medicos)}
        >
          <BsTrash3 /> Eliminar
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}
